import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import isBrowserSupported from 'utils/isBrowserSupported';


const buildVersion = BUILD_VERSION; // eslint-disable-line no-undef

function filterEventsCausedByAdBlock (event) {
  const BLOCKED_PATTERNS = [
    'bad http status: 0',
    'failed to fetch feature flags from posthog'
  ];

  const message = (event.message || '').toLowerCase();
  const exceptionValue = (event.exception?.values?.[0]?.value || '').toLowerCase();

  return BLOCKED_PATTERNS.some(pattern =>
    message.includes(pattern) || exceptionValue.includes(pattern)
  );
}

export default function setupSentry (config) {
  const browserIsNotSupported = !isBrowserSupported(config.SUPPORTED_BROWSERS);
  if (browserIsNotSupported) {
    return;
  }

  Sentry.init({
    dsn: config.SENTRY_DSN,
    dist: 'webpack',
    environment: config.ENVIRONMENT,
    sendDefaultPii: true,
    normalizeDepth: 10,
    maxBreadcrumbs: 100,
    ignoreErrors: [

      // ignore request canceled errors
      '[HttpService] API request canceled',
      'Request aborted',
      'ApiError: Request aborted',

      'ChunkLoadError',
      'Network Error',
      'Request failed with status code 500',
      'Request failed with status code 401',
      'Request failed with status code 420',
      '420'
    ],
    denyUrls: [

      // ignore errors from yandex metrika
      /mc\.yandex\.ru/i
    ],
    attachStacktrace: true,
    release: buildVersion,
    beforeSend (event, hint) {
      if (event.level && event.level.toLowerCase() === 'info') {
        return null;
      }
      event.extra = event.extra || {};

      if (filterEventsCausedByAdBlock(event)) {
        return null;
      }

      if (hint.originalException) {
        if (hint.originalException.isValidationError) {
          return;
        }

        // Assign enumerable error properties to extras
        try {
          const keys = Object.keys(hint.originalException);
          if (keys.length) {
            event.extra.errorProperties = {
              ctor: hint.originalException.constructor.name
            };
            keys.forEach(key => {
              event.extra.errorProperties[key] = hint.originalException[key];
            });
          }
        } catch (error) {
          console.warn('[sentry] Failed to assign enumerable error properties to extras', error);
        }
      }
      try {
        JSON.stringify(event);
      } catch (e) {
        console.warn('Circular dependencies in error');

        // remove some info, because of circular dependencies in extra params
        event.extra.errorProperties = {};
      }

      return event;
    },
    integrations: [
      Sentry.browserTracingIntegration({

        // Логика остается той же: нормализация имен транзакций
        beforeNavigate (context) {
          return {
            ...context,
            name: window.location.hash.replace(/\d+/g, '%d')
          };
        }
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error']
      }
      ),
      Sentry.vueIntegration({
        Vue,
        attachProps: true,
        logErrors: true,
        tracing: true,
        tracingOptions: {
          trackComponents: false
        }
      })
    ],
    tracesSampleRate: 0
  });
}
